import { X, Plus } from "lucide-react";

export function Field({ label, hint, children, cols = 1 }) {
  return (
    <div className={`${cols === 2 ? "md:col-span-2" : ""} space-y-2`}>
      <div className="text-[11px] tracking-[0.2em] uppercase text-[#C6A762]">{label}</div>
      {children}
      {hint && <div className="text-[10px] text-[#7d7d7d]">{hint}</div>}
    </div>
  );
}

export function Text({ value, onChange, ...rest }) {
  return <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="input-rotta" {...rest} />;
}

export function Textarea({ value, onChange, rows = 4, ...rest }) {
  return <textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={rows} className="input-rotta" {...rest} />;
}

export function Select({ value, onChange, options }) {
  return (
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="input-rotta">
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}

export function Toggle({ value, onChange, label }) {
  return (
    <button type="button" onClick={() => onChange(!value)} className="flex items-center gap-3 text-sm">
      <span className={`w-10 h-6 rounded-full transition ${value ? "bg-[#C6A762]" : "bg-[#2a2a2a]"} relative`}>
        <span className={`absolute top-0.5 ${value ? "left-4" : "left-0.5"} w-5 h-5 rounded-full bg-white transition`} />
      </span>
      <span className="text-[#E8E8E8]">{label}</span>
    </button>
  );
}

/** Editor for List<string>. Chips + add input. */
export function StringListEditor({ value = [], onChange, placeholder = "Adicionar…", testId }) {
  const add = (v) => {
    const t = String(v || "").trim();
    if (!t) return;
    onChange([...value, t]);
  };
  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex flex-wrap gap-2">
        {value.map((v, i) => (
          <span key={i} className="inline-flex items-center gap-1 pl-3 pr-1 py-1 bg-[#141414] border border-[#2a2a2a] rounded-full text-xs">
            {v}
            <button type="button" onClick={() => onChange(value.filter((_, k) => k !== i))} className="ml-1 w-5 h-5 grid place-items-center rounded-full hover:bg-red-500/20 hover:text-red-400">
              <X size={11} />
            </button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          placeholder={placeholder}
          className="input-rotta flex-1"
          onKeyDown={(e) => {
            if (e.key === "Enter") { e.preventDefault(); add(e.currentTarget.value); e.currentTarget.value = ""; }
          }}
        />
        <button
          type="button"
          className="btn-ghost px-4 rounded-full text-[11px] inline-flex items-center gap-1"
          onClick={(e) => {
            const input = e.currentTarget.previousSibling;
            add(input.value); input.value = "";
          }}
        >
          <Plus size={12} /> Adicionar
        </button>
      </div>
    </div>
  );
}
